//-------------------------------------------
// Author : Julis Pitangso D.
// Last Update : December 04, 2017
//-------------------------------------------

import React from 'react';

import PropTypes from 'prop-types';

import './ProgressBar.less';

function ProgressBar({addingStyle, style, continuous, progress, label, isRemoteView, width, height, fontSize}) {
  const selectedStyle = addingStyle ? style + addingStyle : style;
  // eslint-disable-next-line no-nested-ternary
  const currentProgress = continuous ? 0 : progress > 100 ? 100 : progress;

  const progressbarWidth = isRemoteView ? null : width;
  const progressbarHeight = height;
  const progressbarFontSize = fontSize ? 'inherit' : fontSize;

  const containerStyle = {
    width: progressbarWidth,
  };

  const progressStyle = {
    width: `${currentProgress}%`,
    height: progressbarHeight,
  };

  const textStyle = {
    fontSize: progressbarFontSize,
  };

  return (
    <div className={`fmlx-progressbar ${selectedStyle}`}>
      <div
        className="fmlx-progressbar-container"
        style={containerStyle}
      >
        <div
          className={`${continuous ? 'indeterminate' : ''} fmlx-progressbar-progress`}
          style={progressStyle}
        >
          <p
            className="fmlx-progressbar-text"
            style={textStyle}
          >
            {label}
          </p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  on_going: 'on-going',
  on_hold: 'on-hold',
  error: 'error',
};

ProgressBar.styles = styles;

ProgressBar.propTypes = {
  style: PropTypes.oneOf([styles.on_going, styles.on_hold, styles.error]),
  progress: (props, propName) => {
    if (typeof props[propName] !== 'number') throw new Error('Invalid Props: "progress" should ∈ ℝ ');
    if (props[propName] < 0 || props[propName] > 100)
      throw new Error('Invalid Props: "progress" should be between 0 and 100');
  },
  width: PropTypes.string,
  label: PropTypes.string,
  continuous: PropTypes.bool,
  addingStyle: PropTypes.string,
  isRemoteView: PropTypes.bool,
  height: PropTypes.any,
  fontSize: PropTypes.any,
};

ProgressBar.defaultProps = {
  progress: 0,
  style: ProgressBar.styles.on_going,
  width: '100%',
  label: '',
  height: '24pt',
  continuous: false,
  addingStyle: '',
  isRemoteView: false,
  fontSize: '',
};

export default ProgressBar;
